module.exports = __webpack_public_path__ + "img/beer.88573a20.png";